//State
export const SET_REQUEST_STARTED       = 'REQUEST_STARTED';
export const SET_REQUEST_ENDED         = 'REQUEST_ENDED';
export const SET_BURGER_STATE          = 'SET_BURGER_STATE';
export const SET_CURRENT_POPUP         = 'SET_CURRENT_POPUP';
export const REMOVE_CURRENT_POPUP      = 'REMOVE_CURRENT_POPUP';
export const SET_DEVICE_STATE          = 'SET_DEVICE_STATE';
export const SET_DYNAMIC_LINK          = 'SET_DYNAMIC_LINK';
export const SET_INITIAL_REQUESTS_DONE = 'SET_INITIAL_REQUESTS_DONE';
export const SET_NEWSLETTER_POPUP      = 'SET_NEWSLETTER_POPUP';  
export const SET_MOBILE_APP_BANNER     = 'SET_MOBILE_APP_BANNER';
export const SET_SEARCH_FILTERS        = 'SET_SEARCH_FILTERS';
export const SET_BENEFITS_MAP_MODE     = 'SET_BENEFITS_MAP_MODE';
export const SET_BENEFITS_PAGE_NUM     = 'SET_BENEFITS_PAGE_NUM';
export const SET_SEARCH_STATE          = 'SET_SEARCH_STATE';
export const SET_USER_REQUEST_DONE     = 'SET_USER_REQUEST_DONE';
export const SET_SURVEY_STATUS         = 'SET_SURVEY_STATUS';
export const SET_BENEFITS_STATUS       = 'SET_BENEFITS_STATUS';
export const SET_MEGA_MENU_ID          = 'SET_MEGA_MENU_ID';
export const SET_DRAWER_SUB_MENU       = 'SET_DRAWER_SUB_MENU';

//Config
export const SET_TRANSLATIONS                       = 'SET_TRANSLATIONS';
export const SET_ICON_TYPES                         = 'SET_ICON_TYPES';
export const SET_CITIES_ARR                         = 'SET_CITIES_ARR';
export const SET_MAIN_MENU                          = 'SET_MAIN_MENU';
export const SET_FOOTER_LINKS                       = 'SET_FOOTER_LINKS';
export const SET_CONTENT_URL                        = 'SET_CONTENT_URL';
export const SET_APP_STORE_LINK                     = 'SET_APP_STORE_LINK';
export const SET_CATEGORIES_ARR                     = 'SET_CATEGORIES_ARR';
export const SET_BENEFIT_TYPES                      = 'SET_BENEFIT_TYPES';
export const SET_DEFAULT_GEO                        = 'SET_DEFAULT_GEO';
export const SET_POLICY_URL                         = 'SET_POLICY_URL';
export const SET_PRIVACY_URL                        = 'SET_PRIVACY_URL';
export const SET_CONTENT_WORLDS                     = 'SET_CONTENT_WORLDS';
export const SET_BANNER_INTERVAL                    = 'SET_BANNER_INTERVAL';
export const SET_LOGIN_RETURN                       = 'SET_LOGIN_RETURN';
export const SET_VALIDATE_HOT_USER_RETURN           = 'SET_VALIDATE_HOT_USER_RETURN';
export const SET_FIRST_LOGIN_RETURN                 = 'SET_FIRST_LOGIN_RETURN';
export const SET_LOGIN_FORM_NAME                 = 'SET_LOGIN_FORM_NAME';
export const SET_WORK_PLACES                        = 'SET_WORK_PLACES';
export const SET_DISCOUNT_DEBIT_BANNER              = 'SET_DISCOUNT_DEBIT_BANNER'
export const SET_SEARCH_IS_NETWORK                  = 'SET_SEARCH_IS_NETWORK'
export const SET_USER_DATA                          = 'SET_USER_DATA';
export const SET_HOT_SEARCHES                       = 'SET_HOT_SEARCHES';
export const SET_BANNERS_ARR                        = 'SET_BANNERS_ARR';
export const SET_BENEFIT_TYPES_FOR_LOGGED_USERS     = 'SET_BENEFIT_TYPES_FOR_LOGGED_USERS';
export const SET_VERIFICATION_CODE_MAX_ATTAMPS_ERROR= 'SET_VERIFICATION_CODE_MAX_ATTAMPS_ERROR';
export const SET_LOCKDOWN_ERR                       = 'SET_LOCKDOWN_ERR';
export const SET_SUB_CATEGORIES_MENU                = 'SET_SUB_CATEGORIES_MENU';
export const SET_MAIN_CATEGORIES_MENU               = 'SET_MAIN_CATEGORIES_MENU';
export const UPDATE_CART_ITEMS                      = 'UPDATE_CART_ITEMS';
export const SET_ORDER_DONE                         = 'SET_ORDER_DONE';
export const UPDATE_USER_COMMENT                    = 'UPDATE_USER_COMMENT';
export const ORDER_STATUS_ARR                       = 'ORDER_STATUS_ARR';
export const SET_SORT_ARR                           = 'SET_SORT_ARR';
export const SET_SURVEY                             = 'SET_SURVEY';
export const SHOW_FIRST_LOGIN_POPUP                 = 'SHOW_FIRST_LOGIN_POPUP';
export const SET_TAX_PERCENT                        = 'SET_TAX_PERCENT';
export const SET_IS_FIRST_REGISTRATION_NEEDED       = 'SET_IS_FIRST_REGISTRATION_NEEDED';
export const SET_USER_ID_LOGIN                      = 'SET_USER_ID_LOGIN';
export const SET_USER_PHONE_LOGIN                      = 'SET_USER_PHONE_LOGIN';
export const SET_TRADE_BENEFIT_CHARGE_TYPES         = 'SET_TRADE_BENEFIT_CHARGE_TYPES';
export const SET_TYPES_WHAT_REQUIRE_USER_VALIDATION = 'SET_TYPES_WHAT_REQUIRE_USER_VALIDATION';
export const SET_HOME_PAGE_BANNERS_INTERVAL         = 'SET_HOME_PAGE_BANNERS_INTERVAL';
export const SET_HOME_PAGE_SLIDER_TYPES             = 'SET_HOME_PAGE_SLIDER_TYPES';
export const SET_TRADE_BENEFIT_TYPE                 = 'SET_TRADE_BENEFIT_TYPE';
export const SET_VEHICLE_AD_DISPLAY_TYPES           = 'SET_VEHICLE_AD_DISPLAY_TYPES';
export const SET_CAR_LEAD_SERVER_ERROR              = 'SET_CAR_LEAD_SERVER_ERROR';
export const SET_MAX_CATEGORIES                     = 'SET_MAX_CATEGORIES';
export const SET_MAX_SUB_CATEGORIES                 = 'SET_MAX_SUB_CATEGORIES';
export const SET_MEGA_MENU                          = 'SET_MEGA_MENU';
export const SET_INSURANCE_DATA                     = 'SET_INSURANCE_DATA';
export const UPDATE_USER_DATA                       = 'UPDATE_USER_DATA';
export const SET_HOMEPAGE_LOGOS                     = 'SET_HOMEPAGE_LOGOS';

//Search Benefits Page
export const SET_SELECTED_FILTERS                   = 'SET_SELECTED_FILTERS';

export const SET_FILTERED_DISCOUNT_DEBIT_BENEFITS   = 'SET_FILTERED_DISCOUNT_DEBIT_BENEFITS'

export const SET_DISCOUNT_DEBIT_SEARCH_FILTERS      = 'SET_DISCOUNT_DEBIT_SEARCH_FILTERS';

//Data
export const SET_AUTOCOMPLETE_RESULTS       = 'SET_AUTOCOMPLETE_RESULTS';
export const SET_AUTOCOMPLETE_STATUS        = 'SET_AUTOCOMPLETE_STATUS';
export const SET_CONTACT_PAGE               = 'SET_CONTACT_PAGE';
export const SET_CONTENT_DATA               = 'SET_CONTENT_DATA';
export const SET_OUR_STORY                  = 'SET_OUR_STORY';
export const SET_BENEFIT_PAGE               = 'SET_BENEFIT_PAGE';
export const SET_HOMEPAGE_DATA              = 'SET_HOMEPAGE_DATA';
export const SET_HOMEPAGE_SECONDARY_SLIDERS = 'SET_HOMEPAGE_SECONDARY_SLIDERS';
export const SET_APP_DOWN_STATUS            = 'SET_APP_DOWN_STATUS';
export const SET_LEAD_STATUS                = 'SET_LEAD_STATUS';
export const SET_FILTERED_BENEFITS          = 'SET_FILTERED_BENEFITS';
export const ADD_FILTERED_BENEFITS          = 'ADD_FILTERED_BENEFITS';
export const SET_PIN_BENEFITS               = 'SET_PIN_BENEFITS';
export const SET_NEWSLETTER_STATUS          = 'SET_NEWSLETTER_STATUS';
export const SET_NEWSLETTER_SUBSCRIPTION_RESULT_TEXT          = 'SET_NEWSLETTER_SUBSCRIPTION_RESULT_TEXT';
export const SET_META_TAGS                  = 'SET_META_TAGS';
export const SET_POLICY_PAGE_ID             = 'SET_POLICY_PAGE_ID';
export const RESET_PIN_BENEFITS             = 'RESET_PIN_BENEFITS';
export const SET_SUPPLIER_JOIN_PAGE         = 'SET_SUPPLIER_JOIN_PAGE';
export const SET_CLIENT_JOIN_PAGE           = 'SET_CLIENT_JOIN_PAGE';
export const SET_USER_APP                   = 'SET_USER_APP';
export const SET_SUPP_APP                   = 'SET_SUPP_APP';
export const SET_POPUPS_TRANSLATIONS        = 'SET_POPUPS_TRANSLATIONS';
export const RESET_BENEFIT_STATUS           = 'RESET_BENEFIT_STATUS';
export const SET_BENEFIT_STATUS             = 'SET_BENEFIT_STATUS';
export const SET_VIP_BENEFIT_STATUS         = 'SET_VIP_BENEFIT_STATUS';
export const VIP_MESSAGE                    = 'VIP_MESSAGE';
export const SET_WALLET_PAGE                = 'SET_WALLET_PAGE';
export const SET_MEMBERSHIP_PAGE            = 'SET_MEMBERSHIP_PAGE';
export const SET_MEMBERSHIP_RETURN          = 'SET_MEMBERSHIP_RETURN';
export const SET_MEMBERSHIP_ERR             = 'SET_MEMBERSHIP_ERR';
export const SET_FAVORITES_DATA             = 'SET_FAVORITES_DATA';
export const ADD_FAVORITE                   = 'ADD_FAVORITE';
export const REMOVE_FAVORITE                = 'REMOVE_FAVORITE';
export const SET_BENEFIT_ACQUIRED           = 'SET_BENEFIT_ACQUIRED';
export const SET_BENEFIT_ACQUIRED_ERR       = 'SET_BENEFIT_ACQUIRED_ERR';
export const SET_FREE_SEARCH_DATA           = 'SET_FREE_SEARCH_DATA';
export const SET_FREE_SEARCH_RECORDS        = 'SET_FREE_SEARCH_RECORDS';
export const RESET_FREE_SEARCH_RECORDS      = 'RESET_FREE_SEARCH_RECORDS';
export const OTP_RESPONSE                   = 'OTP_RESPONSE';
export const SET_TELECARD_URL               = 'SET_TELECARD_URL';
export const SET_AVAILABLE_COUPON           = 'SET_AVAILABLE_COUPON';
export const SET_AVAILABLE_COUPON_ERR       = 'SET_AVAILABLE_COUPON_ERR';
export const SET_BENEFIT_PURCHASED          = 'SET_BENEFIT_PURCHASED';
export const SET_EXPERTS_PAGE               = 'SET_EXPERTS_PAGE';
export const SET_EXPERT_LEAD                = 'SET_EXPERT_LEAD';
export const SET_COUPON_PAY_RESULT          = 'SET_COUPON_PAY_RESULT';
// export const SET_CONSENTS_RESPONSE          = 'SET_CONSENTS_RESPONSE';
export const SET_IS_UPDATED_CONSENTS          = 'SET_IS_UPDATED_CONSENTS';
export const SET_IS_MARKETING_APPROVED          = 'SET_IS_MARKETING_APPROVED';
export const SET_IS_CONSENTS_UPDATE_SUCCESSFUL          = 'SET_IS_CONSENTS_UPDATE_SUCCESSFUL';
export const SET_STREET_LIST                = 'SET_STREET_LIST';
export const SET_COUPON                     = 'SET_COUPON';
export const SET_CART                       = 'SET_CART';
export const SET_CART_REQUEST               = 'SET_CART_REQUEST';
export const SET_USER_ORDERS                = 'SET_USER_ORDERS';
export const SET_FILTERS                    = 'SET_FILTERS';
export const SET_USER_DETAILED_ORDER        = 'SET_USER_DETAILED_ORDER';
export const SET_HOMEPAGE_SEARCH_QUERY      = 'SET_HOMEPAGE_SEARCH_QUERY';
export const SET_USER_WAIVER_AGREEMENTS     = 'SET_USER_WAIVER_AGREEMENTS';
export const SET_VERIFICATION               = 'SET_VERIFICATION';
export const SET_ORDER_NOT_RECEIVED         = 'SET_ORDER_NOT_RECEIVED';
export const SET_LANDING_PAGE_DATA          = 'SET_LANDING_PAGE_DATA';
export const SET_MAIL_LINK_PAGE             = 'SET_MAIL_LINK_PAGE';
export const SET_ORDER_SMART_WALLET         = 'SET_ORDER_SMART_WALLET';
export const SET_VEHICLE_ADS_PAGE           = 'SET_VEHICLE_ADS_PAGE';
export const SET_LOGIN_CODE                 = 'SET_LOGIN_CODE';
export const SET_LOGIN_ID                 = 'SET_LOGIN_ID';
export const SET_VEHICLE_ADS_ON_SUCCESS     = 'SET_VEHICLE_ADS_ON_SUCCESS';
export const SET_ONLY_BENEFITS              = 'SET_ONLY_BENEFITS';
export const SET_ONLY_TRADES                = 'SET_ONLY_TRADES';
export const SET_TUTORIAL_DISPLAY_NUMBER    = 'SET_TUTORIAL_DISPLAY_NUMBER';
export const SET_BENEFITS_ARRAY             =  'SET_BENEFITS_ARRAY';
export const SET_SEARCH_BENEFITS_ARRAY      =  'SET_SEARCH_BENEFITS_ARRAY';
export const SET_SHOULD_SHOW_TABS           =  'SET_SHOULD_SHOW_TABS';
export const SET_LEAD_FORM_VALID            =  'SET_LEAD_FORM_VALID';
export const ADD_MAGAZINE_CRUMB             =  'ADD_MAGAZINE_CRUMB';
export const SET_MAGAZINE_CATEGORIES        =  'SET_MAGAZINE_CATEGORIES';
export const SET_HOMEPAGE_MAGAZINE_ARTICLES =  'SET_HOMEPAGE_MAGAZINE_ARTICLES';
export const SET_LEGAL_ADVICE_PAGE = 'SET_LEGAL_ADVICE_PAGE';
export const SET_LEGAL_ADVICE_QUESTION = 'SET_LEGAL_ADVICE_QUESTION';
export const RESET_LEGAL_ADVICE_QUESTION = 'RESET_LEGAL_ADVICE_QUESTION';
export const SET_LEGAL_ADVICE_QUESTIONS = 'SET_LEGAL_ADVICE_QUESTIONS';
export const SET_LEGAL_ADVICE_QUESTION_RESULTS = 'SET_LEGAL_ADVICE_QUESTION_RESULTS';
export const RESET_LEGAL_ADVICE_QUESTION_RESULTS = 'RESET_LEGAL_ADVICE_QUESTION_RESULTS';
export const SET_LEGAL_ADVICE_QUESTION_SUBMIT = 'SET_LEGAL_ADVICE_QUESTION_SUBMIT';
export const RESET_LEGAL_ADVICE_QUESTION_SUBMIT = 'RESET_LEGAL_ADVICE_QUESTION_SUBMIT';
export const SET_ALL_BENEFITS = 'SET_ALL_BENEFITS';

export const SET_ALL_FILTERS = 'SET_ALL_FILTERS';

export const SET_CATEGORY_BENEFITS = 'SET_CATEGORY_BENEFITS';
export const SET_DATA_SHARING_CONFIG = 'SET_DATA_SHARING_CONFIG';
export const SET_CONSENTS_CONFIG  = 'SET_CONSENTS_CONFIG';
export const SET_PARAMETER = 'SET_PARAMETER';
